var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('documents-list',{attrs:{"resource-id":_vm.driverData.id,"resource-type":"driver"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }